// Libraries
import React from "react";
import { Link } from "react-router-dom";

// Assets
import "./../assets/styles/HamburgerMenu.css";

const HamburgerMenu = () => {
    const toggleCheckbox = () => {
        const root = document.querySelector(":root");
        const close = document.getElementById("hamburger-menu").right = getComputedStyle(root).getPropertyValue("--hamburger-hidden");
        const open = document.getElementById("hamburger-menu").right = getComputedStyle(root).getPropertyValue("--hamburger-show");
        const hamburger = document.getElementById("hamburger-menu");
        const sidebar = document.getElementById("sidebar-menu");

        hamburger.right = open ? close : open;
        sidebar.right = open ? close : open;
        hamburger.visibility = "hidden" ? "visible" : "hidden";
        sidebar.visibility = "hidden" ? "visible" : "hidden";
        document.getElementById("hamburger-input").checked = false;
    };

    return (
        <div id="hamMenu">
            <input type="checkbox" id="hamburger-input" class="burger-shower" />
            <label id="hamburger-menu" for="hamburger-input">
                <nav id="sidebar-menu">
                    <ul>
                        <li><Link to="/" className="link" onClick={() => toggleCheckbox()}>Home</Link></li>
                        <li><Link to="/about" className="link" onClick={() => toggleCheckbox()}>About</Link></li>
                        <li><Link to="/contact" className="link" onClick={() => toggleCheckbox()}>Contact</Link></li>
                    </ul>
                </nav>
            </label>
        </div>
    );
};

export default HamburgerMenu;